var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsedChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_713_2495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0H1.06667C0.477563 0 0 0.467181 0 1.04348V9.3913C0 9.9676 0.477563 10.4348 1.06667 10.4348H9.6C10.1891 10.4348 10.6667 9.9676 10.6667 9.3913V1.04348C10.6667 0.467181 10.1891 0 9.6 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 13.5654H1.06667C0.477563 13.5654 0 14.0326 0 14.6089V22.9567C0 23.533 0.477563 24.0002 1.06667 24.0002H9.6C10.1891 24.0002 10.6667 23.533 10.6667 22.9567V14.6089C10.6667 14.0326 10.1891 13.5654 9.6 13.5654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5336 0H16.0003C15.4112 0 14.9336 0.467181 14.9336 1.04348V9.3913C14.9336 9.9676 15.4112 10.4348 16.0003 10.4348H24.5336C25.1227 10.4348 25.6003 9.9676 25.6003 9.3913V1.04348C25.6003 0.467181 25.1227 0 24.5336 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2669 24.0002C17.3216 24.0002 14.9336 21.6641 14.9336 18.7828C14.9336 15.9015 17.3216 13.5654 20.2669 13.5654C23.2123 13.5654 25.6003 15.9015 25.6003 18.7828C25.5969 21.6628 23.2109 23.997 20.2669 24.0002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_2495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedChat);
export default __webpack_public_path__ + "static/media/collapsed-chat.12ea42686513bf7a2614336447cb4f87.svg";
export { ForwardRef as ReactComponent };